export enum TooltipState {
    None = 1,
    Loading,
    Done
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/inventory/components/import-tab/tooltip-state.ts